import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Programs from "../pages/programs/page";
import Donate from "../pages/donate/page";
import Training from "../pages/training/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/programs",
    element: <Programs />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/training",
    element: <Training />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;